import { render, staticRenderFns } from "./HeaderCard.vue?vue&type=template&id=d2b87eda&scoped=true&"
import script from "./HeaderCard.vue?vue&type=script&lang=js&"
export * from "./HeaderCard.vue?vue&type=script&lang=js&"
import style0 from "./HeaderCard.vue?vue&type=style&index=0&id=d2b87eda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2b87eda",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VContainer,VDivider,VIcon,VList,VListItem,VListItemContent,VListItemGroup,VListItemIcon})
